import Vue from 'vue'

// 简易全局 i18n 状态（Vue2）
export const i18nStore = Vue.observable({
  lang: (typeof window !== 'undefined' && localStorage.getItem('lang')) || 'zh'
})

export const setLang = (lang) => {
  i18nStore.lang = lang === 'en' ? 'en' : 'zh'
  if (typeof window !== 'undefined') {
    localStorage.setItem('lang', i18nStore.lang)
    const html = document.querySelector('html')
    if (html) {
      html.setAttribute('lang', i18nStore.lang)
      html.setAttribute('data-lang', i18nStore.lang) // 添加data-lang属性用于样式切换
    }

    // 语言切换后强制刷新页面，确保所有组件文本立即更新
    if (typeof window !== 'undefined') {
      window.location.reload()
    }
  }
}

const dict = {
  zh: {
    'nav.home': '首页',
    'nav.brandTitle': '美利居',
    'nav.hotel': '美利居酒店',
    'nav.alibaba': '酒店用品采购',
    'nav.teamwork': '合作流程',
    'nav.about': '关于我们',
    'nav.join':'加入我们',
    'nav.share': '邂逅宁静',
    'nav.sleep': '安心睡眠',
    'nav.lang.zh': '中',
    'nav.lang.en': 'EN',

    // Slogans / Titles
    'slogan.line1': '自由邂逅宁静',
    'slogan.line2': '停留亦是归属',
    'brand.origin.title': '品牌起源',
    'brand.origin.text': '美利居的灵感，源于自然界中的美学大师园丁鸟。它们以巧思编织巢穴，筑就伙伴相聚的欢鸣之所。受其对「美与自由」的启发，美利居愿为每一位旅人筑造这样的栖所。\n自由自在，择美而居，美利居由此创立。',

    // Company/About
    'about.brand.title': '美利居',
    'about.company.text': '美利居品牌隶属杭州美利居酒店管理有限公司，其团队有20+年酒店行业管理经验。公司本着"以人为本、创新发展、稳健经营、服务世界"的经营理念，开展酒店管理服务及旅游投资业务。',

    // Home/Share description
    'share.desc': '美利居巧思规划每一处共享空间，精心构筑轻社交场景。舒适的沙发角落、雅致的休闲区域，皆为交流而生。入住于此，客人可随心畅谈、携手探索，在轻松氛围中共享惬意出行时光。',

    // Sleep page
    'sleep.exclusive.title': '美利居独家定制',
    'sleep.exclusive.subtitle1': 'MetaTree',
    'sleep.exclusive.subtitle2': 'Exclusively Custom',
    'sleep.bedding.title': '专属床品，睡眠无忧',
    'sleep.bedding.desc': '美利居深度调研住客真实睡眠需求，匠心研制专属床品。从面料选材到工艺设计，每一处细节都精准契合不同睡眠偏好，为每位住客提供舒心的睡眠体验，一夜酣眠，从此无忧。',

    // QR labels
    'qrcode.wechat': '官方公众号',
    'qrcode.apply': '加盟申请',
    'qrcode.mini': '官方小程序',
    'qrcode.hire': '店长招聘',

    // Contact (full lines)
    'contact.booking': '官方预订服务热线:13641727695(08:00-20:00)',
    'contact.franchise': '加盟热线:13761509408;18721383199(08:00-20:00,节假日休息)',
    'contact.franchise.email': '加盟邮箱:zfd@mljhotels.com',
    'contact.email': '合作邮箱:1120962733@qq.com',
    'contact.pc.booking': '官方预订服务热线: 13641727695(08:00-20:00)',
    'contact.pc.franchise': '加盟热线: 13761509408;18721383199(08:00-20:00,节假日休息)',
    'contact.pc.franchise.email': '加盟邮箱: zfd@mljhotels.com',
    'contact.pc.email': '合作邮箱: 1120962733@qq.com',

    // Teamwork
    'teamwork.title': '合作流程',
    'teamwork.mode': '合作模式',
    'teamwork.process': '合作流程',
    'teamwork.consult': '合作咨询',
    'teamwork.scan': '扫码登记',
    'teamwork.hotline': '加盟热线',
    'teamwork.property': '物业条件',
    'teamwork.fee': '收费标准',
    'teamwork.loc': '地理位置',
    'teamwork.type': '物业性质',
    'teamwork.ownership': '产权清晰',
    'teamwork.rooms': '房间数',
    'teamwork.facilities': '公区配套',
    'teamwork.investor': '投资人',
    'teamwork.loc.value': '长三角城市优先\n坐落核心商圈、大学、医院、景点',
    'teamwork.type.value': '商业、写字楼',
    'teamwork.ownership.value': '土地使用权证、房产证、\n建设工程消防验收意见书',
    'teamwork.rooms.value': '80-200间',
    'teamwork.facilities.value': '大堂、餐厅、健身房、洗衣房\n共享办公、停车场',
    'teamwork.investor.value': '认可美利居价值观，有餐饮经验优先',
    'teamwork.term': '加盟期限',
    'teamwork.software': '软件维护费',
    'teamwork.deposit': '合作保证金',
    'teamwork.design': '工程设计费',
    'teamwork.training': '员工培训费',
    'teamwork.management': '项目托管费',
    'teamwork.decorate': '装修委托费',
    'teamwork.term.value': '不限',
    'teamwork.software.value': '800元',
    'teamwork.deposit.value': '0元',
    'teamwork.design.value': '0元',
    'teamwork.training.value': '0元',
    'teamwork.management.value': '营业总收入*5%',
    'teamwork.decorate.value': '装修总支出*15%',

    // Hire
    'hire.ReserveChainHotelGeneralManager':'连锁酒店储备店长',
    'hire.ReserveChainHotelGeneralManager.duty.value':'1.负责连锁酒店的日常管理和运营工作\n2.监督并确保酒店服务质量和客户满意度\n3.制定并执行酒店营销策略和业务拓展计划\n',
    'hire.ReserveChainHotelGeneralManager.qualification.value':'1.具备中高端连锁酒店的全面运营管理经验，熟悉酒店各部门服务及管理流程；\n2.有自助早餐管理经验；\n3.具有良好的团队领导能力和沟通协调能力；\n4.能够有效处理酒店运营中的各种问题；\n5.有一定英语口语能力者优先；\n6.能够接受公司安排调派国内任意城市工作者优先。\n',
    'hire.ReserveChainHotelGeneralManager.salary':'薪资：面议',

    'hire.RoomAttendant':'客房服务员',
    'hire.RoomAttendant.duty.value':'1.按酒店客房清洁标准，及时、高效清洁房间卫生；\n2.根据酒店清洁要求，按时做好单项清洁和大清洁；\n3.为宾客提供干净、温馨的客房并提供快捷的服务；\n4.完成上级指派的其他任务；\n',
    'hire.RoomAttendant.qualification.value':'1.五官端正，身体健康；\n2.品行端正，能吃苦耐劳，愿意投身酒店服务业，服务意识强；\n3.具有酒店客房保洁工作经历优先。\n',
    'hire.RoomAttendant.salary':'薪资：面议',

    'hire.FrontDeskReceptionist':'酒店前台',
    'hire.FrontDeskReceptionist.duty.value':'1.为宾客提供接待、预订、问讯、结账等快速、准确的服务；\n2.主动、热情、礼貌、耐心、周到地接待宾客，使顾客有宾至如归之感；\n3.严格执行酒店各项服务标准和考核任务，努力树立酒店良好的品牌和公众形象；\n4.配合上级工作，服从上级领导指挥，团结并善于帮助同事工作；\n5.积极参加培训，不断提高业务技能。\n',
    'hire.FrontDeskReceptionist.qualification.value':'1.身体健康，无纹身，形象气质佳；\n2.品行端正，能吃苦耐劳，愿意投身酒店服务业，服务意识强；\n3.适应白夜轮班，团结同事，积极热情；\n4.熟练使用电脑及办公软件，较强的沟通能力及一定英语口语能力，有酒店前台工作经验优先。\n',
    'hire.FrontDeskReceptionist.salary':'薪资：面议',

    'hire.SecurityPersonnel':'安保',
    'hire.SecurityPersonnel.duty.value':'1.负责酒店日常安全巡逻与监控，及时发现并处理安全隐患，确保宾客及酒店财产的安全；\n2.主动维持酒店公共秩序，礼貌引导宾客，提供必要的安全协助与服务，树立酒店安全、专业的形象；\n3.严格执行酒店安全管理制度和应急预案，熟练应对突发事件，包括火警、医疗急救等紧急情况；\n4.配合部门负责人完成各项工作安排，服从指挥，与各部门保持良好协作，共同保障酒店运营顺畅；\n5.积极参加岗位技能与安全知识培训，持续提升应急处理能力和服务水平。\n',
    'hire.SecurityPersonnel.qualification.value':'1.身体健康，无纹身，形象端正，无不良嗜好及犯罪记录；\n2.具备四级消防设施操作员国家职业资格证书；\n3.责任心强，作风严谨，具备较强的安全意识和服务意识，能适应高强度值班工作；\n4.适应24小时轮班制度，具备团队合作精神，沟通协调能力良好；\n5.熟悉基本安防设备及消防知识，有安保或相关工作经验者优先。\n',
    'hire.SecurityPersonnel.salary':'薪资：面议',

    'hire.title':'美利居人才招聘',
    'hire.Contact':'联系方式：dingjieyu@mljhotels.com',
    'hire.duty':'职责概述：',
    'hire.qualification':'任职资格：',

  },
  en: {
    'nav.home': 'Home',
    'nav.brandTitle': 'MetaTree',
    'nav.hotel': 'MetaTree Hotel',
    'nav.alibaba': 'Hotel Supplies Procurement',
    'nav.teamwork': 'Collaboration Process',
    'nav.about': 'About Us',
    'nav.join':'Join Us',
    'nav.share': 'Discover Serenity',
    'nav.sleep': 'Sleep Experience',
    'nav.lang.zh': '中',
    'nav.lang.en': 'EN',

    // Slogans / Titles
    'slogan.line1': 'Where freedom meets peace',
    'slogan.line2': 'Staying becomes belonging',
    'brand.origin.title': 'Brand Story',
    'brand.origin.text': 'The inspiration for MetaTree comes from bowerbirds, the aesthetic master in nature. With ingenious creativity, these birds craft their nests, creating vibrant spaces where companions gather and chirp joyfully. Inspired by their pursuit of "beauty and freedom," MetaTree aspires to build such a space for every traveler. \n"When Freedom Meets Peace It\'s Where You Belong." — this\u00A0is the essence from which MetaTree was born.',

    // Company/About
    'about.brand.title': 'MetaTree',
    'about.company.text': 'MetaTree operates under Hangzhou MetaTree Hotel Management Co., Ltd., with a leadership team bringing over 20 years of collective hospitality expertise. The company adheres to the philosophy of "People-Oriented, Inno\u00ADvative Devel\u00ADopment, Prudent Opera\u00ADtion, and Serve the World", engaging in hotel manage\u00ADment services and tourism in\u00ADvestment.',

    // Home/Share description
    'share.desc': 'At MetaTree, every shared space is thoughtfully curated to foster effortless mingling. From inviting lounge seating alcoves to elegantly designed leisure zones, each area is conceived for meaningful interaction. Here, guests naturally converse, discover together, and weave shared memories – all while savoring the joy of travel in an atmosphere of unhurried ease.',

    // Sleep page
    'sleep.exclusive.title': 'MetaTree Exclusively Custom',
    'sleep.exclusive.subtitle1': 'MetaTree',
    'sleep.exclusive.subtitle2': 'Exclusively Custom',
    'sleep.bedding.title': 'Exclusive Bedding, Sound Sleep Guaranteed',
    'sleep.bedding.desc': 'MetaTree conducts in-depth research on guests’ real sleep needs to meticulously develop exclusive bedding. From fabric selection to craftsmanship, every detail is precisely tailored to diverse sleep preferences, ensuring a comfortable and worry-free night’s rest for each guest.',

    // QR labels
    'qrcode.wechat': 'WeChat\nOfficial\u00A0Account',
    'qrcode.apply': 'Franchise Application',
    'qrcode.mini': 'WeChat\nMini‑programme',
    'qrcode.hire': 'Manager Recruitment',

    // Contact
    'contact.booking':'Official Booking Hotline: 13641727695(08:00-20:00)',
    'contact.franchise':'Franchise Hotline: 13761509408;18721383199(08:00-20:00, Closed on Public Holidays)',
    'contact.franchise.email':'Franchise Email: zfd@mljhotels.com',
    'contact.holiday':'Closed on Public Holidays',
    'contact.email':'Collaboration Email: 1120962733@qq.com',
    'contact.pc.booking': 'Official Booking Hotline: 13641727695(08:00-20:00)',
    'contact.pc.franchise': 'Franchise Hotline: 13761509408;18721383199(08:00-20:00, Closed on Public Holidays)',
    'contact.pc.2.franchise': 'Franchise Hotline: 13761509408;18721383199(08:00-20:00, Closed on Public Holidays)',
    'contact.pc.franchise.email': 'Franchise Email: zfd@mljhotels.com',
    'contact.pc.email': 'Collaboration Email: 1120962733@qq.com',

    // Teamwork
    'teamwork.title': 'Collaboration Process',
    'teamwork.mode': 'Cooperation Models',
    'teamwork.process': 'Collaboration Process',
    'teamwork.consult': 'Collaboration Inquiries',
    'teamwork.scan': 'Scan to Connect',
    'teamwork.hotline': 'Franchise Hotline',
    'teamwork.property': 'Property Requirements',
    'teamwork.fee': 'Fee Schedule',
    'teamwork.loc': 'Location',
    'teamwork.type': 'Property Type',
    'teamwork.ownership': 'Clear Ownership',
    'teamwork.rooms': 'Number of Rooms',
    'teamwork.facilities': 'Public Area Facilities',
    'teamwork.investor': 'Investors',
    'teamwork.loc.value': 'Priority given to Yangtze River Delta cities\nLocated near CBDs, Universities, Hospitals, or Scenic Spots',
    'teamwork.type.value': 'Commercial properties, office buildings',
    'teamwork.ownership.value': 'Land Use Right Certificate, Real Estate Ownership Certificate,\nFire Safety Inspection Certificate for Construction Projects',
    'teamwork.rooms.value': '80-200',
    'teamwork.facilities.value': 'Lobby, restaurant, gym, laundry room\nCo-working space, parking lot',
    'teamwork.investor.value': 'Recognize MetaTree’s values; prior catering experience preferred',
    'teamwork.term': 'Franchise Term',
    'teamwork.software': 'Software Maintenance Fee',
    'teamwork.deposit': 'Collaboration Deposit',
    'teamwork.design': 'Engineering Design Fee',
    'teamwork.training': 'Staff Training Fee',
    'teamwork.management': 'Project Management Fee',
    'teamwork.decorate': 'Decoration Entrustment Fee',
    'teamwork.term.value': 'Unlimited duration',
    'teamwork.software.value': '￥800',
    'teamwork.deposit.value': '￥0',
    'teamwork.design.value': '￥0',
    'teamwork.training.value': '￥0',
    'teamwork.management.value': '5% of total operating revenue',
    'teamwork.decorate.value': '15% of total decoration expenditure',
    
    // Hire
    'hire.ReserveChainHotelGeneralManager':'Reserve Chain Hotel General Manager',
    'hire.ReserveChainHotelGeneralManager.duty.value':'1.Responsible for the daily management and operations of the chain hotel.\n2.Supervise and ensure the quality of hotel services and customer satisfaction.\n3.Develop and implement hotel marketing strategies and business expansion plans.\n',
    'hire.ReserveChainHotelGeneralManager.qualification.value':'1.Comprehensive experience in overall operations management of mid-to-high-end chain hotels, with familiarity in service and management processes across various hotel departments.\n2.Experience in managing self-service breakfast operations.\n3.Strong team leadership, communication, and coordination skills.\n4.Ability to effectively handle various issues arising during hotel operations.\n5.Proficiency in spoken English is preferred.\n6.Willingness to accept reassignment to any city within the country as arranged by the company is preferred.\n',
    'hire.ReserveChainHotelGeneralManager.salary':'Salary: To be negotiated',

    'hire.RoomAttendant':'Room Attendant',
    'hire.RoomAttendant.duty.value':'1.Clean and maintain guest rooms promptly and efficiently according to hotel standards.\n2.Perform routine and deep cleaning tasks as required by hotel guidelines.\n3.Provide guests with clean, comfortable rooms and efficient service.\n4.Complete other tasks assigned by supervisors.\n',
    'hire.RoomAttendant.qualification.value':'1.Presentable appearance and good physical health.\n2.Integrity, hardworking attitude, willingness to commit to the hotel service industry, and strong service awareness.\n3.Prior experience in hotel housekeeping is preferred.\n',
    'hire.RoomAttendant.salary':'Salary: To be negotiated',

    'hire.FrontDeskReceptionist':'Front Desk Receptionist',
    'hire.FrontDeskReceptionist.duty.value':'1.Provide guests with efficient and accurate services, including check-in, reservations, inquiries, and check-out.\n2.Greet guests proactively, enthusiastically, courteously, and patiently, ensuring they feel welcome.\n3.Strictly adhere to hotel service standards and evaluation tasks, striving to uphold the hotel’s brand and public image.\n4.Cooperate with supervisors, follow instructions, and work collaboratively with colleagues.\n5.Actively participate in training to continuously improve professional skills.\n',
    'hire.FrontDeskReceptionist.qualification.value':'1.Good health, no visible tattoos, and a professional appearance.\n2.Integrity, hardworking attitude, willingness to commit to the hotel service industry, and strong service awareness.\n3.Adaptability to day and night shifts, teamwork spirit, and a positive, enthusiastic attitude.\n4.Proficiency in computer and office software, strong communication skills, and basic spoken English skills. Prior experience in hotel front desk operations is preferred.\n',
    'hire.FrontDeskReceptionist.salary':'Salary: To be negotiated',

    'hire.SecurityPersonnel':'Security Personnel',
    'hire.SecurityPersonnel.duty.value':'1.Conduct daily security patrols and monitoring, identify and address potential safety hazards, and ensure the safety of guests and hotel property.\n2.Proactively maintain public order, courteously guide guests, provide necessary safety assistance, and uphold the hotel’s safe and professional image.\n3.Strictly enforce hotel security management systems and emergency protocols, proficiently handling incidents such as fire alarms, medical emergencies, and other urgent situations.\n4.Cooperate with department supervisors, follow instructions, and maintain effective collaboration with other departments to ensure smooth hotel operations.\n5.Actively participate in job skill and safety training to continuously enhance emergency response capabilities and service quality.\n',
    'hire.SecurityPersonnel.qualification.value':'1.Good health, no visible tattoos, presentable appearance, no unhealthy habits or criminal record.\n2.Possession of a National Vocational Qualification Certificate for Level 4 Fire Facility Operator.\n3.Strong sense of responsibility, rigorous work ethic, high safety and service awareness, and ability to adapt to high-intensity shift work.\n4.Adaptability to 24/7 shift schedules, teamwork spirit, and good communication and coordination skills.\n5.Familiarity with basic security equipment and fire safety knowledge. Prior experience in security or related fields is preferred.\n',
    'hire.SecurityPersonnel.salary':'Salary: To be negotiated.',
    
    'hire.title':'MetaTree Talent Acquisition',
    'hire.Contact':'Contact Us：dingjieyu@mljhotels.com',
    'hire.duty':'Job Overview:',
    'hire.qualification':'Qualifications:',

  }
}

export const t = (key) => {
  const lang = i18nStore.lang || 'zh'
  const val = (dict[lang] && dict[lang][key]) || null
  if (val == null) return key
  // 允许字符串中的 \n 按需换行
  return String(val).replace(/\\n/g, '\n')
}

export default { t, i18nStore, setLang }


